import { TimeEntryView } from "@/shared/modules/typescript-trustapi-client/models/time-entry-view";
import { Role } from "@/trust-admin-app/models/user";
import { EventInput } from '@fullcalendar/core';
import { floor } from "lodash";
import moment from "moment";

export function accessPermitted(userRoles: Role[], allowedRoles: Role[] = []): boolean {
  let accessAllowed = false;
  userRoles.forEach((x) => {
    if (allowedRoles.filter(y => y == x).length > 0) {
      accessAllowed = true;
    }
  });
  return accessAllowed;
}

let eventGuid = 0;
export function createEventId(): number {
  return eventGuid++;
}

export function m2h(min: number): string {
  return `${min / 60 ^ 0}`.slice(-2) + ':' + ('0' + min % 60).slice(-2)
}

export function eventTransform(event: any[]): EventInput[] {
  return event.map(x => {
    return {
      id: floor(Math.random() * 10000) as any,
      title: formatEventTitle(x),
      start: x.startDateTime,
      end: x.endDateTime,
      display: 'block',
      allDay: x.isAllDayEvent,
      backgroundColor: getEventBGColour(x),
      borderColor: getEventBorderColour(x),
      textColor: getEventTextColour(x),
      eventItem: x,
    }
  });
}

export function eventPublicHolidayTransform(event: any[]): EventInput[] {
  return event.map(x => {
    return {
      id: floor(Math.random() * 10000) as any,
      title: x.name,
      allDay: true,
      start: x.date,
      backgroundColor: '#638886',
      borderColor: '#638886',
      textColor: '#ffffff',
      publicHoliday: x,
    }
  });
}

export function formatEventTitle(event: any): string {
  if(!event.eventType) {
    return event.title;
  } else if(event.eventType.id == 3) {
    return event.title;
  } else {
    return moment(event.startDateTime).format('HH:mm') +
    ' - ' + moment(event.endDateTime).format('HH:mm') + ' ' + event.title;
  }
}

export function getEventBGColour(event: any): string {
  if(!event.eventType) {
    return 'rgba(242, 101, 34, 0.1)';
  } else if(event.eventType.id == 2) {
    return '#D8CFBC';
  } else if(event.eventType.id == 1 && event.timeEntryActivity.id == 1) {
    return '#394F5A';
  } else if(event.eventType.id == 1) {
    return '#9EA5AB';
  } else if(event.eventType.id == 3) {
    return '#638886';
  } else {
    return 'red';
  }
}

export function getEventBorderColour(event: any): string {
  if(!event.eventType) {
    return 'rgba(242, 101, 34, 0.1)';
  } else if(event.eventType.id == 2) {
    return '#D8CFBC';
  } else if(event.eventType.id == 1 && event.timeEntryActivity.id == 1) {
    return '#394F5A';
  } else if(event.eventType.id == 1) {
    return '#9EA5AB';
  } else if(event.eventType.id == 3) {
    return '#638886';
  } else {
    return 'red';
  }
}

export function getEventTextColour(event: any): string {
  if(!event.eventType) {
    return 'rgb(240, 100, 35)';
  } else if(event.eventType.id == 2) {
    return '#000000';
  } else if(event.eventType.id == 1 && event.timeEntryActivity.id == 1) {
    return '#FFFFFF';
  } else if(event.eventType.id == 1) {
    return '#FFFFFF';
  } else if(event.eventType.id == 3) {
    return '#ffffff';
  } else {
    return '#000000';
  }
}

export function escapeString(x: string) {
  try {
    return '"' + x.replace(/"/g, '""') + '"';
  } catch (error) {
    return '';
  }
}

export function createCSV(filename: string, data: string) {
  const exportedFilenmae = filename + '.csv';
  const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) { // feature detection
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', exportedFilenmae);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}